import { render, staticRenderFns } from "./birthday.vue?vue&type=template&id=5d29e648&scoped=true&"
import script from "./birthday.vue?vue&type=script&lang=js&"
export * from "./birthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d29e648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d29e648')) {
      api.createRecord('5d29e648', component.options)
    } else {
      api.reload('5d29e648', component.options)
    }
    module.hot.accept("./birthday.vue?vue&type=template&id=5d29e648&scoped=true&", function () {
      api.rerender('5d29e648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/header_block/notification/birthday.vue"
export default component.exports